module.exports = __webpack_public_path__ + "img/add-white.64717a76.svg";